import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BlindIcon(props: IconProps) {
    return <Icon {...props} iconKey={"blind"}/>
}
